export default __webpack_public_path__ + "/dist/images/5028615.e843da5a72536cf2b898f4c0b187ff65.png";